export default __webpack_public_path__ + "static/media/ENFERMAGEM.93a7a11a.pdf";